import BaseService from "../baseService";
class ServicosPrestados extends BaseService {
  constructor(id) {
    const resource = "servico-prestado";
    let relationship = { csv: "csv" };
    super(id, relationship, resource);
  }
}

export default (id) => new ServicosPrestados(id);
